// extracted by mini-css-extract-plugin
export default {"title":"CheckboxList_title__pa22A","row":"CheckboxList_row__sUvRK"};